<template>
  <div
      class=" position-absolute w-100"/>
  <div class="cert-top d-flex flex-row"></div>
  <div class="cert-nav-container-sm d-xl-none d-flex flex-row">
    <a class="cert-nav-logo d-flex d-xl-none flex-row" href="//cyber.gov.rw" target="_blank" style="margin-left: 16px">
      <div class="cert-nav-logo-text my-auto">NCSA</div>
    </a>
    <div class="d-flex d-xl-none"
         style="width: 1px; background-color: #000000;opacity: 0.2; margin: 0 8px 0 16px;z-index: 5"></div>
    <a class="cert-nav-logo mr-auto d-flex d-xl-none flex-row"
       @click="()=>$router.push({path:'/home'})">
      <div class="cert-nav-logo-text my-auto">RW-CERT</div>
    </a>
    <div @click="displayMenu()" class="ml-auto cert-icon">
      <micon :icon="showMenu?'close':'menu'"/>
    </div>
    <div v-if="showMenu">
      <sidenav-list :cardBg="custom_class" class="" :request-close="onRequestClose"/>
    </div>
  </div>
  <aside
      class="cert-nav-container my-3 p-0 overflow-auto border-0 sidenav navbar border-radius-xl d-none d-xl-flex flex-column"
      id="sidenav-main">
    <div class="col-11 mx-auto cert-sticky">
      <sidenav-list :cardBg="custom_class" class="w-100" :request-close="onRequestClose"/>
    </div>
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";

export default {
  name: "index",
  components: {
    SidenavList
  },
  props: ["custom_class", "layout"],
  data() {
    return {
      showMenu: false,
      prevLink: String,
    };
  },
  methods: {
    displayMenu() {
      this.showMenu = !this.showMenu;
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    onRequestClose() {
      this.showMenu = false;
    },
  },
};
</script>
